import {useEffect,useMemo,useRef,useSyncExternalStore} from 'react';
import {createOpeningClient,openingAccountKey,type OpeningClient} from '../client';
import {createDraft} from '../../browser-recovery/drafts';
import {emptyOpeningDraft,validOpeningDraft} from '../draft';
import type {OpeningAccount} from '../types';
const clients=new Map<string,OpeningClient>();
if(typeof window!=='undefined'){
 window.addEventListener('storage',()=>clients.forEach(c=>c.refreshSaved()));
 window.addEventListener('beforeunload',e=>{if([...clients.values()].some(c=>c.snapshot().pending)){e.preventDefault();e.returnValue='';}});
}
export function useOpeningClient(base:string,account:OpeningAccount,begin?:()=>()=>void){
 const key=openingAccountKey(base,account),live=useRef(key);live.current=key;
 useEffect(()=>{live.current=key;return()=>{live.current='';};},[key]);
 if(!clients.has(key))clients.set(key,createOpeningClient(base,account,begin));
 const client=clients.get(key)!;client.activate(()=>live.current===key);
 const state=useSyncExternalStore(client.subscribe,client.snapshot);
 return {client,key,...state,locked:state.busy||!!state.pending||state.blocked};
}
export function useOpeningDraft(key:string,baseline:string){
 const store=useMemo(()=>createDraft(key,baseline,emptyOpeningDraft(),validOpeningDraft),[key,baseline]);
 const state=useSyncExternalStore(store.subscribe,store.snapshot);
 return {...store,...state,locked:state.stale||state.changedElsewhere||state.unreadable||!!state.error};
}
